import { contact } from "@kanata/shared";

/**
 * The floating WhatsApp button's number and opening message.
 *
 * The number is the store's published one (+62 815 9188 588), confirmed by
 * Kanata on 3 Nov 2026 along with the message.
 */
export const FLOAT_WHATSAPP_DIGITS: string = contact.whatsappDigits;
export const FLOAT_WHATSAPP_MESSAGE =
  "Halo Kanata! Saya ingin tahu lebih lanjut tentang meja elektrik Kanata. Bisa dibantu untuk informasi produk dan katalog?";

/** wa.me opens the app on a phone and WhatsApp Web on a desktop. */
export function floatingWhatsappUrl(digits = FLOAT_WHATSAPP_DIGITS, message = FLOAT_WHATSAPP_MESSAGE): string {
  const base = `https://wa.me/${digits.replace(/\D/g, "")}`;
  const text = message.trim();
  return text ? `${base}?text=${encodeURIComponent(text)}` : base;
}
